export enum Types {
  login_error = 'login_error',
  login_success = 'login_success',
  logout_success = 'logout_success',
  logout_error = 'logout_error',
}
